module.exports = __webpack_public_path__ + "img/code-public.cca989fe.jpg";